import React, { useState } from 'react';
import FileBase64 from 'react-file-base64';
import { message } from 'antd';

const acceptedFiles = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'];
const DEFAULT_MAX_SIZE = 25; // default 25MB

const UploadButton = ({ onDone, multiple, type, maxSize = DEFAULT_MAX_SIZE }) => {
  const [uploadedFiles, setUploadedFiles] = useState(null);

  const checkSingleFileSize = (f) => {
    if (!f || !f.size) return true;
    return (parseInt(f.size, 10) / 1024) <= maxSize;
  };

  const checkSingleFileType = (f) => {
    if (!f || !f.type) return true;
    return acceptedFiles.includes(f.type);
  };

  const validateSize = (filesToCheck = uploadedFiles) => {
    if (!filesToCheck) return true;
    if (Array.isArray(filesToCheck)) {
      return filesToCheck.every(checkSingleFileSize);
    }
    return checkSingleFileSize(filesToCheck);
  };

  const validateType = (filesToCheck = uploadedFiles) => {
    if (!filesToCheck) return true;
    if (Array.isArray(filesToCheck)) {
      return filesToCheck.every(checkSingleFileType);
    }
    return checkSingleFileType(filesToCheck);
  };

  const handleDone = (files) => {
    setUploadedFiles(files);
    const isTypeValid = validateType(files);
    const isSizeValid = validateSize(files);

    let error = null;
    if (!isTypeValid) {
      error = 'Jenis file yang Anda unggah tidak diperbolehkan (hanya JPG, PNG, PDF)';
      message.error(error);
    } else if (!isSizeValid) {
      error = `Ukuran file yang Anda unggah melebihi batas maksimal (${maxSize}MB)`;
      message.error(error);
    }

    if (isTypeValid && isSizeValid) {
      if (onDone) onDone(files, null, files);
    } else {
      if (onDone) onDone(null, error, files);
    }
  };

  return (
    <>
      <FileBase64 multiple={Boolean(multiple)} onDone={handleDone} />
      {!validateType(uploadedFiles) ? <div className="gx-text-danger gx-text-sm">Jenis file yang Anda unggah tidak diperbolehkan</div> : null}
      {!validateSize(uploadedFiles) ? <div className="gx-text-danger gx-text-sm">Ukuran file yang Anda unggah melebihi batas maksimal ({maxSize}MB)</div> : null}
    </>
  );
};

export default UploadButton;